export const msalConfig = {
    "auth": {
            "clientId": "d294b4e4-ac40-4606-a00a-f8b544ae71ef",
            "authority": "https://login.microsoftonline.com/970febc5-27ee-474e-a361-0387d7a1ec62/v2.0",
            //"redirectUri": "https://ttadmin.riceservicesinc.com"
            "redirectUri": "https://localhost:8080/dashboard"
    },
    cache: {
      cacheLocation: "localStorage", // Can also use "sessionStorage"
      storeAuthStateInCookie: true, // Recommended for IE11 or Edge
    },
  };
  
  export const loginRequest = {
    scopes: ["api://d294b4e4-ac40-4606-a00a-f8b544ae71ef/User.Validation"], // Define the scopes you need, like "User.Read" for user profile data
    //scopes: ["profile"], // Define the scopes you need, like "User.Read" for user profile data
  };